function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m15.37 6.7a9.26 9.26 0 0 1 -9.37 9.3 9.27 9.27 0 0 1 -5-1.47 6.81 6.81 0 0 0 .79 0 6.57 6.57 0 0 0 4.07-1.4 3.28 3.28 0 0 1 -3.06-2.21 4.16 4.16 0 0 0 .62.05 3.46 3.46 0 0 0 .86-.11 3.28 3.28 0 0 1 -2.63-3.22 3.31 3.31 0 0 0 1.48.36 3.28 3.28 0 0 1 -1-4.39 9.32 9.32 0 0 0 6.75 3.45 3.71 3.71 0 0 1 -.08-.75 3.28 3.28 0 0 1 5.67-2.24 6.47 6.47 0 0 0 2.08-.79 3.27 3.27 0 0 1 -1.44 1.81 6.58 6.58 0 0 0 1.89-.51 7 7 0 0 1 -1.64 1.7c.01.13.01.28.01.42z",
  fill: "#fff"
});

var SvgIconTwt = function SvgIconTwt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 18,
    viewBox: "0 0 18 18",
    width: 18,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTwt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-twt.3db7b67f.svg";
export { ForwardRef as ReactComponent };